var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCash = function SvgCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#244D5A",
    fillRule: "evenodd",
    d: "M8.196 26.338A13.167 13.167 0 1 1 26.053 7.76 13.166 13.166 0 1 1 8.208 26.356zM19.081 7.013a11.913 11.913 0 1 1 0 23.825 11.913 11.913 0 0 1 0-23.825m.627 18.81h-1.28v-1.092a3.43 3.43 0 0 1-3.259-3.441h1.368c.031.508.2 2.224 2.736 2.224.65.031 1.29-.153 1.822-.524a1.55 1.55 0 0 0 .672-1.29c0-.995-.643-1.714-2.6-2.154-2.969-.672-3.665-1.753-3.665-3.176a3.137 3.137 0 0 1 2.922-3.017v-1.322h1.28v1.273a3.365 3.365 0 0 1 3.38 3.475h-1.377a2.247 2.247 0 0 0-2.5-2.215c-1.35 0-2.325.667-2.325 1.766 0 .979.551 1.46 2.5 1.949 2.356.593 3.761 1.38 3.761 3.362 0 2.187-1.892 3-3.436 3.125v1.059zm3.574-19.378a11.91 11.91 0 0 0-16.508 17.17v-.013A13.173 13.173 0 0 1 23.287 6.445z",
    clipRule: "evenodd"
  })));
};
export default SvgCash;